import { lazy, memo, Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import LayoutClient from 'src/layouts/layout';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import RouteGuard from 'src/routes/guard';
import { Routes as Router } from 'src/routes/route';
import InitAppProvider from './initApp.provider';

const Page404Screen = lazy(() => import('src/screens/errors/page404'));
const Page500Screen = lazy(() => import('src/screens/errors/page500'));
const Page403Screen = lazy(() => import('src/screens/errors/page403'));

const LoginScreen = lazy(() => import('src/screens/auth/login/index'));

const DashboardScreen = lazy(() => import('src/screens/dashboard'));
const FileScreen = lazy(() => import('src/screens/file'));
const CategoryScreen = lazy(() => import('src/screens/category'));
const CustomerScreen = lazy(() => import('src/screens/customer'));
const PostScreen = lazy(() => import('src/screens/post'));
const PostCreateScreen = lazy(() => import('src/screens/post/create'));
const PostEditScreen = lazy(() => import('src/screens/post/edit'));
const SettingScreen = lazy(() => import('src/screens/setting'));

function RouteProvider() {
  return (
    <Routes>
      <Route
        element={
          <InitAppProvider>
            <RouteGuard>
              <LayoutClient />
            </RouteGuard>
          </InitAppProvider>
        }
      >
        <Route path={Router.HOME.path} element={<DashboardScreen />} />
        <Route path={Router.FILE.path} element={<FileScreen />} />
        <Route path={Router.CATEGORY.path} element={<CategoryScreen />} />
        <Route path={Router.CUSTOMER.path} element={<CustomerScreen />} />
        <Route path={Router.SETTING.path} element={<SettingScreen />} />
        <Route path={Router.POST.path} element={<PostScreen />} />
        <Route path={Router.POST_CREATE.path} element={<PostCreateScreen />} />
        <Route path={`${Router.POST_EDIT.path}/:id`} element={<PostEditScreen />} />
      </Route>

      <Route
        element={
          <Suspense fallback={<SpinnerLoader bg={false} />}>
            <Outlet />
          </Suspense>
        }
      >
        <Route path={Router.LOGIN.path} element={<LoginScreen />} />

        <Route path={Router.PAGE500.path} element={<Page500Screen />} />
        <Route path={Router.PAGE403.path} element={<Page403Screen />} />

        <Route path="*" element={<Page404Screen />} />
      </Route>
    </Routes>
  );
}

export default memo(RouteProvider);
